// // Simple Product Recommendations Component
// class ProductRecommendations {
//   constructor() {
//     this.init();
//   }

//   init() {
//     this.loadRecommendations();
//     this.setupQuickAdd();
//   }

//   // Load product recommendations via AJAX
//   async loadRecommendations() {
//     const containers = document.querySelectorAll('product-recommendations');
    
//     containers.forEach(async (container) => {
//       const url = container.dataset.url;
//       if (!url) return;

//       try {
//         const response = await fetch(url);
//         const html = await response.text();
        
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const newContent = doc.querySelector('product-recommendations');
        
//         if (newContent && newContent.innerHTML.trim()) {
//           container.innerHTML = newContent.innerHTML;
//           this.setupQuickAdd(); // Re-setup quick add for new content
//         }
//       } catch (error) {
//         console.error('Failed to load recommendations:', error);
//       }
//     });
//   }

//   // Setup quick add functionality
//   setupQuickAdd() {
//     const quickAddButtons = document.querySelectorAll('.quick-add__submit');
    
//     quickAddButtons.forEach(button => {
//       // Remove existing listeners to prevent duplicates
//       button.removeEventListener('click', this.handleQuickAdd);
//       button.addEventListener('click', this.handleQuickAdd.bind(this));
//     });
//   }

//   async handleQuickAdd(e) {
//     e.preventDefault();
    
//     const button = e.target;
//     const form = button.closest('form');
//     if (!form) return;

//     const formData = new FormData(form);
//     const originalText = button.textContent;
    
//     button.classList.add('loading');
//     button.disabled = true;

//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: { 'X-Requested-With': 'XMLHttpRequest' }
//       });

//       if (response.ok) {
//         button.textContent = 'Added!';
//         button.classList.add('success');
//         this.updateCartCount();
//       } else {
//         throw new Error('Failed to add to cart');
//       }
//     } catch (error) {
//       console.error('Quick add error:', error);
//       button.textContent = 'Error';
//       button.classList.add('error');
//     } finally {
//       setTimeout(() => {
//         button.textContent = originalText;
//         button.classList.remove('loading', 'success', 'error');
//         button.disabled = false;
//       }, 2000);
//     }
//   }

//   // Update cart count
//   async updateCartCount() {
//     try {
//       const response = await fetch('/cart.js');
//       const cart = await response.json();
      
//       document.querySelectorAll('.cart-count').forEach(counter => {
//         counter.textContent = cart.item_count;
//       });
//     } catch (error) {
//       console.error('Failed to update cart count:', error);
//     }
//   }
// }

// // Register custom element
// customElements.define('product-recommendations', class extends HTMLElement {
//   connectedCallback() {
//     if (!this.initialized) {
//       new ProductRecommendations();
//       this.initialized = true;
//     }
//   }
// });

// // Initialize when DOM is ready
// document.addEventListener('DOMContentLoaded', () => {
//   new ProductRecommendations();
// });


class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);